import React from 'react'
import * as Styled from './Switch.styles'
import useId from 'hooks/useId'

const Switch = ({ id, ...rest }) => {
  const uuid = useId(id)
  return (
    <Styled.Switch>
      <input { ...rest } id={ uuid } type='checkbox' />
      <label htmlFor={ uuid }>
        <span className='button' />
      </label>
    </Styled.Switch>
  )
}

export default Switch
